<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box" v-if="!loading">   
      <div class="dhy-details-box">  
        <div class="dhy-list-box"> 
          <ul v-if="stype != 6">
            <li><p class="date">公司名称</p> <p class="time">{{company.name | kong}}</p></li>
            <li><p class="date">所属地域</p> <p class="time">{{company.area | kong}}</p></li>
            <li><p class="date">英文名称</p> <p class="time">{{company.name_en | kong}}</p></li>
            <li><p class="date">所属行业</p> <p class="time">{{company.industry | kong}}</p></li> 
            <li><p class="date">证券简称</p> <p class="time">{{company.shortname | kong}}</p></li> 
            <li>
              <p class="date">曾 用 名</p> 
              <p class="time">
            <!-- {{company.area | kong}} -->
              <a href="javascript:;" v-if="!company.oldname ||　company.oldname.length==0"> - </a>
              <template v-if="company.oldname &&　company.oldname.length>0">
                <a href="javascript:;" v-for="h in company.oldname">
                  {{ h.name | kong }}</a>
              </p>
              </template>
            </li> 
            <li><p class="date">公司网址</p> <p class="time">{{company.website | kong}}</p></li> 
            <li><p class="date">董　　秘</p> <p class="time">{{company.secretaries | kong}}</p></li> 
            <li><p class="date">法人代表</p> <p class="time">{{company.legalRepresentative | kong}}</p></li> 
            <li><p class="date">注册资本</p> <p class="time">{{company.regmoney | thousands}}{{company.regmoneyunit}}</p></li> 
            <li><p class="date">电　　话</p> <p class="time">{{company.phone | kong}}</p></li> 
            <li><p class="date">传　　真</p> <p class="time">{{company.fax | kong}}</p></li> 
            <li><p class="date">邮　　编</p> <p class="time">{{company.postcode | kong}}</p></li> 
            <li><p class="date">办公地址</p> <p class="time">{{company.address | kong}}</p></li> 
          </ul>

          <ul v-if="stype == 6">
            <li class="list">
              <div class="date">公司名称:</div>
              <div class="time"><span>{{company.name| kong}}</span></div>
            </li>
            <li class="list">
              <div class="date">所属地域:</div>
              <div class="time">{{company.area | kong}}</div>
            </li>
            <li class="list">
              <div class="date">主营业务:</div>
              <div class="time">{{company.business | kong}}</div>
            </li>
            <li class="list">
              <div class="date">会　　计:</div>
              <div class="time">{{company.accountant | kong}}</div>
            </li>
            <li class="list">
              <div class="date">律　　师:</div>
              <div class="time">{{company.lawyers | kong}}</div>
            </li>
            <li class="list">
              <div class="date">银　　行:</div>
              <div class="time">{{company.banks | kong}}</div>
            </li>
            <li class="list">
              <div class="date">所属行业:</div>
              <div class="time">{{company.industry}}</div>
            </li>
            <li class="list">
              <div class="date">证券简称:</div>
              <div class="time">{{company.shortname | kong}}</div>
            </li>
            <li class="list">
              <div class="date">公司网址:</div>
              <div class="time">{{company.web | kong}}</div>
            </li>
            <li class="list">
              <div class="date">　 email:</div>
              <div class="time">{{company.email | kong}}</div>
            </li>
            <li class="list">
              <div class="date">　　CEO:</div>
              <div class="time">{{company.ceo | kong}}</div>
            </li>
            <li class="list">
              <div class="date">　董事长:</div>
              <div class="time">{{company.legalRepresentative | kong}}</div>
            </li>
            <li class="list">
              <div class="date">秘　　书:</div>
              <div class="time">{{company.secretary | kong}}</div>
            </li>
            <li class="list">
              <div class="date">上市时间:</div>
              <div class="time">{{company.listingDate | kong}}</div>
            </li>
            <li class="list">
              <div class="date">上市类型:</div>
              <div class="time">{{company.listingcategory | kong}}</div>
            </li>
            <li class="list">
              <div class="date">状　　态:</div>
              <div class="time">{{company.status | kong}}</div>
            </li>
            <li class="list">
              <div class="date">登记地点:</div>
              <div class="time">{{company.transferoffice | kong}}</div>
            </li>
            <li class="list">
              <div class="date">电　　话:</div>
              <div class="time">{{company.phone | kong}}</div>
            </li>
            <li class="list">
              <div class="date">传　　真:</div>
              <div class="time">{{company.fax | kong}}</div>
            </li>
            <li class="list">
              <div class="date">邮　　编:</div>
              <div class="time">{{company.postcode | kong}}</div>
            </li>
            <li class="list">
              <div class="date">更新时间:</div>
              <div class="time">{{company.updtime | kong}}</div>
            </li>
            <li class="list list-w">
              <div class="date">办公地址:</div>
              <div class="time">{{company.address | kong}}</div>
            </li>
          </ul>
        </div> 
      </div>

      <div class="pledge-list-box1" v-if="company.businessscope">   
        <ul>
          <li class="active">主营业务</li>  
          <li><p class="date">经营范围</p><p class="time">{{ company.businessscope }}</p></li> 
        </ul>   
      </div>  
      
      <div class="pledge-box1" v-if="company.biangen.length > 0"> 
        <h3 class="">发行相关</h3>
        <div class="pledge-list-box">
            <ul>
              <li><p class="date">历史沿革</p> </li> 
              <li><p class="date">{{ company.founddate }}</p><p class="time">公司成立</p></li> 
              <li v-for="i in company.biangen">
                <p class="date">{{ i.changedate }}</p>
                <p class="time">
                  变更类型：{{i.item}}
                  <template v-if="i.changebefore && i.changeafter && i.changebefore !== i.changeafter">，变更内容：由{{i.changebefore}}变为{{i.changeafter}}</template>
                  <template v-if="!i.changebefore && i.changeafter">，变更内容：变为{{i.changeafter}}</template>
                </p>
              </li>
          </ul> 
        </div> 
      </div>    
    </div>
  </div>
  
  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind" :style="{'display': tipGoBind ? 'block' : 'none'}">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'CompanyBaseInfo',
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    props: ['companyDetail'],
    data () {
      return {
        //
      }
    },
    route: {
      data({to}) {
      console.log("第一步")
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          console.log()
          console.log("wxcode:" + this.wxcode)
          if (this.wxcode) {
            console.log('weixin denglu success');
            this.wxlogin(this.wxcode)
          } else {
            console.log("this.wxcode is null,login fail")
            this.getProfile(to.query.share)
          }
        }
      console.log("第二步")
      console.log(this.currentuser)
        if (this.currentuser) { 
          console.log('打印toquerystype')
          console.log(to)
          console.log(to.query.stype)
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);
          
          this.setSelectedTab();
          this.detail();
        }
      }
    },
    methods: {
      // 公司信息页
      detail: function () {
        this.loading = true;

        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid
      console.log("baseInfo")
      console.log(query)
        $.ajax({
          url: apiUrl('/V1.0.0/company/detail'),
          method: 'post',
          dataType: 'json',
          // async: false,
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {

            this.company = response.data
            console.log(this.company)
            // this.legendCompany.push(this.company.shortname)

            // if (this.company.executives.length > 0) {
            //   for (let i of this.company.executives) {
            //     if (i.category === 1) {
            //       this.directorNum++
            //     } else if (i.category === 2) {
            //       this.SupervisorsNum++
            //     } else {
            //       this.ExecutiveNum++
            //     }
            //   }
            // }

          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }
</style>


/** WEBPACK FOOTER **
 ** BaseInfo.vue?472e4494
 **/